import { getBrazilianStatus } from "../../../../utils/detectBrazil";
import { nflDashPtBR } from "../../../../components/mappings/sports-dash-mappings/nfl-dash.pt-br";

export const TABS_ID = {
  GAMES: "games",
  STANDINGS: "standings",
  TEAMS: "teams"
};

const DesktopNavigation = ({ activeTab, setActiveTab }) => {
  const isBrazilian = getBrazilianStatus();
  const t = (text) => (isBrazilian ? nflDashPtBR[text] || text : text);

  const tabs = [
    { id: TABS_ID.GAMES, label: t("Games") },
    { id: TABS_ID.STANDINGS, label: t("Standings") },
    { id: TABS_ID.TEAMS, label: t("Teams") }
  ];

  return (
    <div className="border border-white/10 rounded-sm p-4 bg-white/5">
      <div className="flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-3 py-1.5 text-xs font-mono uppercase tracking-widest border transition-all duration-150 ${
              activeTab === tab.id
                ? "bg-white/10 text-white border-white/20"
                : "text-gray-500 border-white/10 hover:text-white hover:border-white/20"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DesktopNavigation;
